import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultCard } from "../Card/Card";

const AppointmentDetailActions = ({ onClick, onNoAnswerClick, onBuyClick, leadType, onBusyClick }) => {
    const {t} = useTranslation();
    return <DefaultCard title={t('appointmentdetailactions.actions')}>
            <button className="btn btn-default" style={{marginRight: "10px"}} onClick={() => onBusyClick()}>{t('appointmentdetailactions.busy')}</button>
            <button className="btn btn-default" style={{marginRight: "10px"}} onClick={() => onNoAnswerClick()}>{t('appointmentdetailactions.noanswer')}</button>
            <button className="btn btn-default" onClick={() => onClick("showSendEmailModal")}>{t('appointmentdetailactions.sendemail')}</button>
            {leadType !== "aoLead" && <button className="btn" onClick={() => onBuyClick("order")}>{t('appointmentdetailactions.placeorder')}</button>}
            {leadType !== "aoLead" && <button className="btn" onClick={() => onBuyClick("close")}>{t('appointmentdetailactions.closebought')}</button>}
            {leadType === "aoLead" && <button className="btn btn-default" onClick={() => onBuyClick("close")}>{t('appointmentdetailactions.buy')}</button>}
            <button className="btn btn-default" style={{marginLeft: "10px"}} onClick={() => onClick("showCloseModal")}>{t('appointmentdetailactions.close')}</button>
        </DefaultCard>
}

export default AppointmentDetailActions;